import React, { FC } from "react";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import FilePreviewHandler from "./FilePreviewHandler";
import { downloadAndCloseImgStyles } from "../components/customerManagement/CustomerDetailsStyles";
import closeModelIcon from "../assets/modal-closing-icon.png";
import downloadIcon from "../assets/download-icon.png";
type FilePreviewDialogProps = {
  open: boolean;
  downloadUrl: string;
  handleClose: () => void;
  previewFileUrl?: string;
  previewFile?: File;
  setDownloadUrl: (url: string) => void;
  showDownload?: boolean;
};

const FilePreviewDialog: FC<
  FilePreviewDialogProps & { contentType?: string }
> = ({
  open,
  downloadUrl,
  handleClose,
  previewFileUrl,
  previewFile,
  setDownloadUrl,
  showDownload = true,
  contentType,
}) => {
  const handleDownloadClick = async () => {
    try {
      const response = await fetch(downloadUrl, {
        method: "GET",
      });

      if (!response.ok) {
        throw new Error("Network response was not ok.");
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = "downloaded_file";
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading the file:", error);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <DialogActions>
          <Box
            sx={{
              display: "flex",
            }}
          >
            {showDownload && (
              <span
                style={{
                  paddingRight: "22px",
                }}
              >
                <img
                  style={downloadAndCloseImgStyles}
                  src={downloadIcon}
                  alt="download-icon"
                  onClick={handleDownloadClick}
                />
              </span>
            )}
            <span>
              <img
                style={downloadAndCloseImgStyles}
                src={closeModelIcon}
                alt="close-icon"
                onClick={handleClose}
              />
            </span>
          </Box>
        </DialogActions>
      </DialogTitle>

      <DialogContent>
        <FilePreviewHandler
          fileUrl={previewFileUrl}
          uploadedFile={previewFile}
          isUploadedFile={!previewFileUrl}
          onFileReady={(url) => setDownloadUrl(url)}
          contentType={contentType}
        />
      </DialogContent>
    </Dialog>
  );
};

export default FilePreviewDialog;
